var app = angular.module("leonardo");

var UnitListActions = function($scope, $attrs, ngDialog, $timeout, AccountService, AuthDataService, PermissionService) {

  $scope.permissionService = PermissionService;

  $scope.showAddUnitDialogAdd = function() {
    if ((AccountService.getCollection().length > 1) && AuthDataService.isNotStaff()) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/account/select.html',
        controller: 'SelectAccountDialog',
        className: 'ngdialog-theme-default ngdialog-select-account'
      }).then(function (account) {
        if (account) {
          $timeout(function() {
            ngDialog.open({
              template: 'views/templates/dialog/unit/unit-form.html',
              className: 'ngdialog-theme-default ngdialog-template-edit',
              controller: 'UnitForm',
              data: {
                mode: 'create',
                property: $attrs.property,
                account: (account !== 'all') ? account : null
              }
            });
          }, 200);
        }
      });
    }
    else {
      ngDialog.open({
        template: 'views/templates/dialog/unit/unit-form.html',
        className: 'ngdialog-theme-default ngdialog-template-edit',
        controller: 'UnitForm',
        data: {
          mode: 'create',
          property: $attrs.property,
          account: AuthDataService.authData.account.id
        }
      });
    }
  };
};

app.controller('UnitListActions', ['$scope', '$attrs', 'ngDialog', '$timeout', 'AccountService', 'AuthDataService', 'PermissionService', UnitListActions]);
